define('AllBrands.View', [
    'all_brands.tpl',
    'AllBrands.BrandByLetter.View',
    'Categories',
    'Categories.Model',
    'Facets.Helper',
    'Facets.Model',
    'AjaxRequestsKiller',
    'Backbone.CollectionView',
    'Backbone',
    'jQuery',
    'underscore',
    'Utils'
], function AllBrandsView(
    allBrandsTpl,
    AllBrandsBrandByLetterView,
    Categories,
    CategoriesModel,
    FacetsHelper,
    FacetsModel,
    AjaxRequestsKiller,
    BackboneCollectionView,
    Backbone,
    jQuery,
    _,
    Utils
) {
    'use strict';

    return Backbone.View.extend({
        template: allBrandsTpl,
        initialize: function initialize(options) {
            var categoryUrl;
            var url;
            var catUrl;
            var categoryModel;

            this.options = options;
            this.application = options.application;
            this.translatorConfig = this.application.translatorConfig;
            this.brandConfig = this.application.getConfig('AllBrands');
            categoryUrl = this.getCategoryUrl();
            url = categoryUrl.split('?')[0];
            this.translator = FacetsHelper.parseUrl(
                categoryUrl,
                this.translatorConfig,
                true
            );
            this.model = new FacetsModel();
            this.model.options = {
                data: this.translator.getApiParams(),
                killerId: AjaxRequestsKiller.getKillerId(),
                pageGeneratorPreload: true
            };
            this.categoriesTopLevelUrl = Categories.getTopLevelCategoriesUrlComponent();
            this.isCategoryPage = !!_.find(this.categoriesTopLevelUrl, function find(categoryTopLevelUrlParam) {
                var categoryTopLevelUrl = Utils.correctURL(categoryTopLevelUrlParam);
                catUrl = Utils.correctURL(url);
                return catUrl.indexOf(categoryTopLevelUrl) === 0;
            });

            if (this.isCategoryPage) {
                categoryModel = new CategoriesModel();
                categoryModel.options = {
                    data: {
                        fullurl: this.translator.getCategoryUrl()
                    },
                    killerId: AjaxRequestsKiller.getKillerId()
                };
                this.model.set('category', categoryModel);
            }
        },
        getCategoryUrl: function getCategoryUrl() {
            var self = this;
            var fullUrl = Backbone.history.fragment;
            var paths = fullUrl.split('/');
            var categoryPaths;

            paths = _.compact(paths);
            categoryPaths = _.reject(paths, function reject(path) {
                return path === self.brandConfig.pageUrl;
            });

            return categoryPaths.join('/');
        },
        beforeShowContent: function beforeShowContent() {
            var self = this;
            var promise = jQuery.Deferred();
            var models = [this.model];
            var categoryModel = this.model.get('category');
            var brandFacet;

            if (categoryModel) {
                models.push(categoryModel);
            }

            jQuery.when
                .apply(null, _.invoke(models, 'fetch', {}))
                .then(function then() {
                    self.translator.setLabelsFromFacets(self.model.get('facets') || []);
                    brandFacet = _.findWhere(self.model.get('facets') || [], {
                        id: self.brandConfig.facetId
                    });
                    self.brandValues = (brandFacet && brandFacet.values && brandFacet.values.length) ? brandFacet.values : [];
                    promise.resolve();
                }).fail(function fail() {
                    promise.reject();
                });

            return promise;
        },
        getBrandsByLetter: function getBrandsByLetter() {
            var brands = [{
                letter: '0-9',
                values: []
            }];
            var firstLetter;
            var letterKey;
            var brandHolder;

            _.each(this.brandValues, function each(brand) {
                firstLetter = brand.label[0].toUpperCase();
                if (_.isNaN(parseInt(firstLetter, 10))) {
                    letterKey = _.findWhere(brands, {
                        letter: firstLetter
                    });
                    if (!letterKey) {
                        brands.push({
                            letter: firstLetter,
                            values: []
                        });
                    }
                    brandHolder = _.findWhere(brands, {
                        letter: firstLetter
                    });
                    brandHolder.values.push(brand);
                } else {
                    brands[0].values.push(brand);
                }
            });
            return brands;
        },
        childViews: {
            'BrandsByLetter': function brandsByLetter() {
                var self = this;
                var translator = this.translator;
                var orderedBrands = this.getBrandsByLetter();

                return new BackboneCollectionView({
                    childView: AllBrandsBrandByLetterView,
                    viewsPerRow: 1,
                    collection: new Backbone.Collection(orderedBrands),
                    childViewOptions: {
                        translator: translator,
                        brandConfig: self.brandConfig
                    }
                });
            }
        },
        getTitle: function getTitle() {
            if (this.title) {
                return this.title;
            }
            return this.getPageTitle();
        },
        getPageTitle: function getPageTitle() {
            var category = this.model.get('category');
            var title = (category && category.get('name')) ? category.get('name') : '';

            return (title) ? title + ' Brands' : 'Brands';
        },
        getContext: function getContext() {
            return {
                category: this.getPageTitle()
            };
        }
    });
});
